<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import AgentField from './AgentField.vue';
import AgentSection from './AgentSection.vue';
import { createSectionFormProxy } from './createSectionFormProxy';

const props = defineProps({
  form: { type: Object, required: true },
  canManage: { type: Boolean, default: false },
  isSaving: { type: Boolean, default: false },
  hasAdvancedApprovals: { type: Boolean, default: false },
  pendingApprovalsCount: { type: Number, default: 0 },
});

const emit = defineEmits(['updateField', 'save', 'openRoute']);
const { t: ce } = useI18n();
const formModel = createSectionFormProxy(
  () => props.form,
  payload => emit('updateField', payload)
);
</script>

<template>
  <section id="agent-handoff" class="flex flex-col gap-8" tabindex="-1">
    <AgentSection
      :title="ce('CAPTAIN_EXPERIENCE.AUTO.TRANSFERENCIA_PARA_HUMANO')"
    >
      <form class="grid gap-4" @submit.prevent="emit('save')">
        <fieldset
          :disabled="!canManage"
          class="contents disabled:pointer-events-none disabled:opacity-70"
        >
          <AgentField
            :label="
              ce('CAPTAIN_EXPERIENCE.AUTO.MENSAGEM_DURANTE_O_HORARIO_COMERCIAL')
            "
            control-id="agent-business-hours-handoff"
          >
            <textarea
              id="agent-business-hours-handoff"
              v-model="formModel.businessHoursHandoffMessage"
              class="agent-textarea"
              rows="4"
            />
          </AgentField>
          <AgentField
            :label="ce('CAPTAIN_EXPERIENCE.AUTO.MENSAGEM_FORA_DO_HORARIO')"
            control-id="agent-after-hours-handoff"
          >
            <textarea
              id="agent-after-hours-handoff"
              v-model="formModel.afterHoursHandoffMessage"
              class="agent-textarea"
              rows="4"
            />
          </AgentField>
          <AgentField
            :label="
              ce('CAPTAIN_EXPERIENCE.AUTO.MENSAGEM_PADRAO_DE_TRANSFERENCIA')
            "
            control-id="agent-default-handoff"
          >
            <textarea
              id="agent-default-handoff"
              v-model="formModel.handoffMessage"
              class="agent-textarea"
              rows="3"
            />
          </AgentField>
          <Button
            v-if="canManage"
            type="submit"
            icon="i-lucide-save"
            class="w-fit"
            :is-loading="isSaving"
          >
            {{ ce('CAPTAIN_EXPERIENCE.AUTO.SALVAR_TRANSFERENCIA') }}
          </Button>
        </fieldset>
      </form>
    </AgentSection>

    <AgentSection
      v-if="hasAdvancedApprovals && canManage"
      :title="ce('CAPTAIN_EXPERIENCE.AUTO.APROVACOES_AGORA')"
    >
      <p class="text-sm leading-relaxed text-n-slate-11">
        {{
          ce('CAPTAIN_EXPERIENCE.SCRIPT.PENDING_APPROVALS_COUNT', {
            count: pendingApprovalsCount,
          })
        }}
      </p>
      <Button
        class="mt-3"
        color="slate"
        variant="faded"
        icon="i-lucide-wrench"
        :label="ce('CAPTAIN_EXPERIENCE.SCRIPT.OPEN_TOOLS')"
        @click="emit('openRoute', 'captain_account_tools_index')"
      />
    </AgentSection>
  </section>
</template>

<style scoped>
.agent-textarea {
  @apply w-full rounded-lg border border-n-weak bg-n-alpha-black2 px-3 py-2.5 text-sm leading-normal text-n-slate-12 outline-none transition placeholder:text-n-slate-10 hover:border-n-slate-6 focus:border-n-brand focus:ring-2 focus:ring-n-brand/20;
  resize: vertical;
}
</style>
